// src/pages/serviceslist/Services.jsx
import React, { useEffect, useState } from "react";
import "./Services.scss";
import { getServicesList } from "services/serviceslist/services";
import { useNavigate } from "react-router-dom";

const Services = ({ 
  limit, 
  showHeader = true,           // ← Naya prop (Home pe hide karne ke liye)
  showDescription = true,      // ← Naya prop (Home pe short desc hide kar sakte ho)
  hideLoadMore = false         // ← Naya prop (Home pe "Load More" na dikhe)
}) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-");

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      // Agar limit diya hai (jaise Home pe 3), toh sirf utna hi fetch karo
      const res = await getServicesList({ page: 1, limit: limit || 100 });
      if (res?.code === 200) {
        setServices(res.data.services || []);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  // Final display count — agar limit hai toh wahi, warna infinite load more
  const displayCount = limit ? Math.min(limit, services.length) : services.length;

  return (
    <div className="services-page">

      {/* Header sirf tab dikhao jab showHeader true ho */}
      {showHeader && (
        <header className="services-header">
          <h2>Our Services</h2>
          <p>Premium home healthcare services tailored for your family</p>
        </header>
      )}

      {loading ? (
        <p className="loading-text">Loading services...</p>
      ) : services.length === 0 ? (
        <p className="no-services">No services available</p>
      ) : (
        <>
          <div className="services-grid">
            {services.slice(0, displayCount).map((service) => {
              const imageUrl = service.imageUrl;
              const hasImage = imageUrl && imageUrl.trim() !== "";

              return (
                <div
                  key={service.id}
                  className="service-card"
                  onClick={() => navigate(`/service/${slugify(service.title)}`)}
                >
                  <div className="service-img">
                    {hasImage ? (
                      <img src={imageUrl} alt={service.title} loading="lazy" />
                    ) : (
                      <div className="no-image-box">
                        <span>No Image</span>
                      </div>
                    )}
                  </div>

                  <div className="service-content">
                    <h3>{service.title}</h3>
                    
                    {/* Short description only if showDescription true */}
                    {showDescription && <p>{service.shortdesc}</p>}
                    
                    <button
                      className="read-more-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/service/${slugify(service.title)}`);
                      }}
                    >
                      Read More →
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Load More button — Home pe hide karne ke liye */}
          {!hideLoadMore && !limit && services.length > 6 && (
            <div className="load-more-wrapper">
              <button 
                className="load-more-btn" 
                onClick={() => window.scrollTo(0, document.body.scrollHeight)}
              >
                Load More Services
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Services;